import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { loadNewsletter, loadNewsletters } from '../actions';
import DocumentMeta from 'react-document-meta';
import SocialShareButtons from '../components/SocialShareButtons';
import Newsletter from '../components/home/HomeNewsletter/Newsletter';

const splitCopyIntoParagraphs = (content) => {
    content = content.split(/\n\s*\n/g).map(line => `<p>${line}</p>`).join('');

    return content
}

// This code is for the newsletter detail page
class NewsletterDetail extends Component {
    constructor(props) {
        super(props);
        this.handleNewsletterClick = this.handleNewsletterClick.bind(this);
    }
    
    handleNewsletterClick = (newsletterId) => {
        this.props.loadNewsletter(newsletterId);
        // Construct the URL for the newsletter detail page
        const newsletterDetailURL = '/newsletter/' + newsletterId;

        // Open the URL in a new tab
        //window.open(newsletterDetailURL, '_blank');
        // Push the newsletter detail page to the browser
        this.props.push(newsletterDetailURL);
    }

    // Load all newsletter data from the API
    componentDidMount() {
        const newsletterId = this.props.params.id;
        this.props.loadNewsletter(newsletterId);
        this.props.loadNewsletters();

        if (typeof(window) !== "undefined") {
            window.scrollTo(0,0)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (typeof(window) !== "undefined") {
            window.scrollTo(0,0)
        }
    }
    
    render() {
        if (this.props.homePageNewsletters.isLoading) {
            return <span />;
        }
        if (this.props.getNewsletter.isLoading) {
            return <span />;
        }

        // Get the first newsletter from the list
        let selectedNewsletterData = this.props.getNewsletter || null;
        if (!selectedNewsletterData) {
            return <span />;
        }

        // Get fields from the newsletter data
        let newsletterImage = selectedNewsletterData.header_image || null;
        let newsletterImageMobile = selectedNewsletterData.header_image_mobile || null;
        let newsletterTitle = selectedNewsletterData.title || '';
        let content = selectedNewsletterData.newsletter_copy || '';
        let newsletterCreated = selectedNewsletterData.created || '';
        let newsletterStatusChanged = selectedNewsletterData.newsletter_status_changed || '';
        let newsletterExcerpt = selectedNewsletterData.excerpt || '';
        let newsletterId = selectedNewsletterData.id || '';
        let featuredNewsletterId = newsletterId;

        // Format the date
        let newsletterDate = new Date(newsletterStatusChanged);
        let newsletterDateFormatted = newsletterDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

        function createMarkup(content) {
            var splitCopy = splitCopyIntoParagraphs(content);
            return { __html: splitCopyIntoParagraphs(content).split('\n').join('') };
        }

        //let newsletterCopy = createMarkup(content);
        let newsletterCopy = <div className="story-copy" dangerouslySetInnerHTML={createMarkup(content)}></div>;
    
        let meta = {
            title: `WorldWideWomen | ${newsletterTitle}`,
            description: `${newsletterExcerpt}`,
            canonical: `https://worldwidewomen.co/newsletter/${newsletterId}`,
            meta: {
              property: {
                'og:type': 'article',
                'og:image': `${newsletterImage}`,
                'og:title': `WorldWideWomen | ${newsletterTitle}`,
                'og:description': `${newsletterExcerpt}`,
                'og:site_name': 'WorldWideWomen',
                'og:url': `https://worldwidewomen.co/newsletter/${newsletterId}`
              }
            },
            auto: {
              ograph: true,
            },
          }

        let newsletterBannerElem = <img src={newsletterImage} alt={newsletterTitle} />;
        let path = this.props.router.location.pathname;

        // Get the rest of the newsletters
        let newsletterCards = this.props.homePageNewsletters
            .filter(newsletter => newsletter.id !== featuredNewsletterId) // skip newsletter with id featuredNewsletterId
            .map((newsletter, index) => {
            return <div key={newsletter.id} className="newsletterDetail-newsletterCardWrapper">
                <Newsletter
                    key={index}
                    newsletter={newsletter}
                    onClick={this.handleNewsletterClick.bind(this, newsletter.id)}
                />
            </div>;
        });
        

        return(
            <main>
                <DocumentMeta {...meta} />
                <div className="content-wrapper">
                    <div className="storyDetail-wrapper">
                        <div className="storyDetail-bannerWrapper">
                            <div className="storyDetail-banner">
                                {newsletterBannerElem}
                            </div>

                            <div className="storyDetail-titleWrapperOuter">
                                <div className="storyDetail-titleWrapper">
                                    <h5 style={{fontSize: '2.5rem', marginBottom: '0.7rem', fontWeight: '100'}}>FEARLESS FEMALE NEWSLETTER:</h5>
                                    <h4 style={{marginBottom: '1rem'}}>{newsletterTitle}</h4>

                                    <div className="storyDetail-date">{newsletterDateFormatted}</div>
                                    <div className="vialink">Via <Link href="/what-we-do">WorldWideWomen</Link></div>
                                    
                                    <div style={{display: 'inline-block', height: '3rem', width: 'auto'}} className="storyDetail-socialShareBtnWrapper">
                                        <SocialShareButtons
                                            storyTitle={newsletterTitle}
                                            path={path}
                                        />
                                    </div>

                                    
                                </div>
                                
                            </div>

                        </div>

                        <div className="storyDetail-copyWrapper">
                            {newsletterCopy}

                        </div>

                    </div>
                </div>

                <div className="newsletterDetail-newsletterCardWrapperOuter">
                    <div className="content-wrapper">
                        <div className="storyDetail-storyCardHeader">
                            YOU MIGHT ALSO LIKE...
                        </div>
                        <div className="newsletterDetail-newsletterCardsInnerWrapper">
                            {newsletterCards}
                        </div>
                    </div>
                </div>
                
            </main>
        
        );
    }
}

function mapStateToProps(state) {
    return state;
};

export default connect(
    mapStateToProps,
    {
        Link,
        push,
        loadNewsletters,
        loadNewsletter,
    }
)(NewsletterDetail);


// WEBPACK FOOTER //
// ./src/containers/NewsletterDetail.jsx